const childRoutes = prop => [
    {
        path: 'form',
        name: prop + '.form',
        meta: { auth: true },
        component: () => import('../pages/vagrant/Form.vue')
    },
    {
        path: 'list',
        name: prop + '.list',
        meta: { auth: true },
        component: () => import('../pages/vagrant/List.vue')
    }
]
const routes = [
    {
        path: '/rehabilitation-vagrant-service/vagrant',
        name: 'rehabilitation_vagrant_service.vagrant',
        component: () => import('@/layouts/RehabilitationVagrantService.vue'),
        meta: { auth: true },
        children: childRoutes('rehabilitation_vagrant_service.vagrant')
    }
]

export default routes
